module.exports = __webpack_public_path__ + "static/media/015_shinsyuku.74466210.gif";